import { createElement } from 'react';
import './index.scss';
import { Input as NextInput, Icon } from '@alifd/next';
const Input = ({ value, onClick, children, onChange, onClear, onPressEnter, onFocus, onBlur, ...otherProps }) => {
    const _otherProps = otherProps || {};
    const legacyClearable = _otherProps.clearable;
    const legacyReadonly = _otherProps.readonly;
    const legacyBorder = _otherProps.border;
    const legacyPrefix = _otherProps.prefix;
    const legacySuffix = _otherProps.suffix;
    const legacyPrefixIcon = _otherProps.prefixIcon;
    const legacySuffixIcon = _otherProps.suffixIcon;
    const legacyIconSize = _otherProps.iconSize;
    const hasClear = _otherProps.hasClear ?? legacyClearable;
    const readOnly = _otherProps.readOnly ?? legacyReadonly;
    const hasBorder = _otherProps.hasBorder ?? legacyBorder;
    delete _otherProps.clearable;
    delete _otherProps.readonly;
    delete _otherProps.border;
    delete _otherProps.prefix;
    delete _otherProps.suffix;
    delete _otherProps.prefixIcon;
    delete _otherProps.suffixIcon;
    delete _otherProps.iconSize;
    const innerBefore = legacyPrefixIcon || legacyPrefix ? (createElement("div", { style: { display: 'flex', alignItems: 'center' } },
        legacyPrefixIcon &&
            createElement(Icon, { type: legacyPrefixIcon, size: legacyIconSize }),
        legacyPrefix && createElement("span", null, legacyPrefix))) : null;
    const innerAfter = legacySuffix || legacySuffixIcon ? (createElement("div", { style: { display: 'flex', alignItems: 'center' } },
        legacySuffix && createElement("span", null, legacySuffix),
        legacySuffixIcon &&
            createElement(Icon, { type: legacySuffixIcon, size: legacyIconSize }))) : null;
    const nextProps = {
        ..._otherProps,
    };
    if (hasClear !== undefined)
        nextProps.hasClear = hasClear;
    if (readOnly !== undefined)
        nextProps.readOnly = readOnly;
    if (hasBorder !== undefined)
        nextProps.hasBorder = hasBorder;
    if (innerBefore && nextProps.innerBefore == null)
        nextProps.innerBefore = innerBefore;
    if (innerAfter && nextProps.innerAfter == null)
        nextProps.innerAfter = innerAfter;
    if (onClick)
        nextProps.onClick = onClick;
    if (children != null)
        nextProps.children = children;
    if (onChange)
        nextProps.onChange = onChange;
    if (onClear)
        nextProps.onClear = onClear;
    if (onPressEnter)
        nextProps.onPressEnter = onPressEnter;
    if (onFocus)
        nextProps.onFocus = onFocus;
    if (onBlur)
        nextProps.onBlur = onBlur;
    if (value !== undefined && value !== null) {
        nextProps.value = value;
        if ('defaultValue' in nextProps) {
            delete nextProps.defaultValue;
        }
    }
    return createElement(NextInput, nextProps);
};
Input.displayName = 'Input';
export default Input;
